import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
import StepTabs from "./StepTabs";
import "./TransactionDetail.css";
import { RiskAssesContinueForm } from "./forms/risk-assesment/riskassesscontinueForm";
import { useRiskAssessmentContinued } from "../hooks/useRiskAssessmentContinuedData";
import useCountries from "../hooks/useCountries";
import FloatingQueryCenter from "./FloatingQueryCenter";
import ConfirmationModal from "./ui/ConfirmationModal";
import LoaderModal from './Loader';
import { useNavigate, useSearchParams } from "react-router-dom";
import ViewModeBanner from "./ui/ViewModeBanner";
const RiskAssesContinue = ({isReport}) => {

  const {
    formData,
    setFormData,
    handleChange,
    sendMail,
    handleValidate,
    handleNext,
    saveRiskAssessmentContinued,
    isReadOnly,
    isModalOpen,
    setIsModalOpen,
    isEmailModalOpen,
    setIsEmailModalOpen,
    modalLabel,
    modalMessage,
    loading,
    showSections,
    hasUnsavedChanges,
    isLoading,
    loadingMessage,
    modalOpen,
    modalHeading,
    setIsReadOnly,
    setModalOpen
  } = useRiskAssessmentContinued();

  const countries = useCountries();
  const [searchParams] = useSearchParams();
// Single source of truth for the lock: the status on screen, not the localStorage copy.
const checkStatus = formData?.status === "Validated" && searchParams.get("edit") !== "true";
  const clientFormData = localStorage.getItem("clientFormData");
  const companyName = clientFormData ? JSON.parse(clientFormData).companyName : "";
 const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
     

      <div className={!isReport ? "transaction-detail" : ""}>
        {!isReport && <StepTabs hasUnsavedChanges={hasUnsavedChanges} searchParams={searchParams} />}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.status}
        />
        <div className="form-section">
        <RiskAssesContinueForm
          formData={formData}
          isReport={isReport}
          handleChange={handleChange}
          companyName={companyName}
          isReadOnly={isReadOnly}
          countries={countries}
          handleSubmit={handleSubmit}
          showSections={showSections}
          sendMail={sendMail}
        />
         {!isReport && <RightSidebar />}
         </div>
      </div>

      {!isReport && <BottomBar
        buttons={[
          { label: "Save", onClick: () => saveRiskAssessmentContinued(false) ,skipConfirmation: true, disabled: checkStatus },
          { label: "Validate & Lock", onClick: handleValidate , disabled: checkStatus },
          {
      label: "Back",
      onClick: () => navigate(`/RiskAsses?${searchParams.toString()}`),
      style: {},
      title: "Go back",
      disabled: false,
    },
          { label: "Next", onClick: handleNext }
        ]}
      />}

      {/* Modal Popup */}
      {/* {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  textAlign: "center",
                  position: "relative",
                  width: "300px"
                }}>
            <p>{modalMessage}</p>
            <button onClick={() => setIsModalOpen(false)} style={{
              marginTop: "10px",
              padding: "8px 16px",
              border: "none",
              background: "#07b1b0",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}>Close</button>
          </div>
        </div>
      )} */}

     

{/* {isEmailModalOpen && (
      <div className="modal" style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1
      }}>
        <div className="modal-content" style={{
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
  }}> 
 
          <div style={{textAlign:"left"}}>{modalMessage}</div>
          <button onClick={() => setIsEmailModalOpen(false)} style={{
              marginTop: "10px",
              padding: "8px 16px",
              border: "none",
              background: "#07b1b0",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}>Close</button>
        </div>
      </div>
    )} */}
     <ConfirmationModal
              isOpen={modalOpen}
              heading= {modalHeading}
              message={modalMessage}
              onClose={() => setModalOpen(false)}
            />
    <LoaderModal isOpen={isLoading} message={loadingMessage} />
    <FloatingQueryCenter />
    </>
  );
};

export default RiskAssesContinue;
